<script>
import CardMenu from '@components/client/card-menu.vue';
import CardMenuList from '@components/client/card-menu-list.vue';
import resize from '@utils/image-sizer';

import {
  programMethods,
  clientProgramMethods,
  authComputed,
} from '@state/helpers';

export default {
  components: {
    CardMenu,
    CardMenuList,
  },
  props: {
    program: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      placeholder: require('@assets/images/placeholder-photo-upload.svg'),
      isMenuOpen: false,
      showFeaturedCard: false,
      actionDetails: false,
    };
  },
  computed: {
    ...authComputed,
    coverPhoto() {
      return this.program &&
        this.program.mediaAssets &&
        this.program.mediaAssets.coverPhoto &&
        this.program.mediaAssets.coverPhoto.url
        ? resize(this.program.mediaAssets.coverPhoto.url, 560, 310)
        : this.placeholder;
    },
    isTrainer() {
      return (
        this.roles && this.roles.length > 0 && this.roles[0] === 'isTrainer'
      );
    },
    featuredPrograms() {
      return this.isTrainer && this.program.trainer_id === '0';
    },
  },
  async beforeMount() {},
  mounted() {},
  methods: {
    ...clientProgramMethods,
    ...programMethods,
    async toProgramDetail() {
      this.setSelectedProgram(this.program);
      this.$router
        .push({
          name: 'programDetail',
          params: { id: this.program._id, program: this.program },
        })
        .catch(() => {});
    },
    onDuplicateProgram() {
      this.$emit('duplicate-program', this.program);
    },
    archiveProgram() {
      this.$emit('archive-program', this.program);
    },
    assignClient() {
      this.$bvModal.show('item-select-modal');
    },
  },
};
</script>

<template>
  <div
    class="card-program-container"
    @mouseleave="
      isMenuOpen = false;
      showFeaturedCard = false;
      actionDetails = false;
    "
    @click="toProgramDetail"
  >
    <div
      class="featured-program-default"
      v-show="featuredPrograms && !showFeaturedCard"
      @mouseover="showFeaturedCard = true"
    >
      <img :src="coverPhoto" />
    </div>
    <div
      :class="['card-program-minimal', { featured: featuredPrograms }]"
      v-show="!featuredPrograms || (featuredPrograms && showFeaturedCard)"
    >
      <div>
        <img
          :class="['card-hero', { featured: featuredPrograms }]"
          :src="coverPhoto"
        />
        <div :class="['functionality-actions', { featured: featuredPrograms }]">
          <div
            v-if="!featuredPrograms"
            v-show="!actionDetails"
            class="menu action"
            @click.stop="
              isMenuOpen = !isMenuOpen;
              actionDetails = !actionDetails;
            "
          >
            <img src="@assets/images/icon-three-dots.svg" />
          </div>
          <div
            v-if="isMenuOpen || (featuredPrograms && !isMenuOpen)"
            class="menu action"
            @click.stop="toProgramDetail"
          >
            <img src="@assets/images/icon-chevron-right.svg" />
          </div>
          <CardMenu
            class="action"
            v-if="
              isTrainer && (isMenuOpen || (featuredPrograms && !isMenuOpen))
            "
          >
            <CardMenuList type="assign-client" @assign-client="assignClient" />
          </CardMenu>
          <CardMenu
            class="action"
            v-if="isMenuOpen || (featuredPrograms && !isMenuOpen)"
          >
            <CardMenuList
              type="duplicate-program"
              @handle-duplicate="onDuplicateProgram"
            />
          </CardMenu>
          <CardMenu class="action" v-if="isMenuOpen && !featuredPrograms">
            <CardMenuList
              type="archive-program"
              @archive-program="archiveProgram"
            />
          </CardMenu>
        </div>
      </div>
      <div :class="['card-content', { featured: featuredPrograms }]">
        <h3 v-if="program.label" class="card-title">{{ program.label }}</h3>
        <p v-if="featuredPrograms" class="featured-description">{{
          program.description
        }}</p>
        <div class="card-meta">
          <span>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-calendar'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.4 0v1.2H3.6V0H2.4v1.2h-.6c-.666 0-1.194.54-1.194 1.2L.6 10.8c0 .66.534 1.2 1.2 1.2h8.4c.66 0 1.2-.54 1.2-1.2V2.4c0-.66-.54-1.2-1.2-1.2h-.6V0H8.4zM9 6.6H6v3h3v-3zm-7.2 4.2h8.4V4.2H1.8v6.6z" fill="#fff"/></svg>
            <span class="count">{{ program.programWeeksNumber * 7 }} days</span>
          </span>
          <span v-if="!featuredPrograms">
            <svg width="19" height="14" viewBox="0 0 19 14" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon-dumbbell'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M18.516 6.438h-.703v-2.11c0-.879-.762-1.64-1.641-1.64h-.938c-.088 0-.175.029-.234.029v-.264c0-.879-.762-1.64-1.64-1.64h-.938c-.908 0-1.64.761-1.64 1.64v3.985H7.968V2.453c0-.879-.762-1.64-1.64-1.64H5.39c-.909 0-1.641.761-1.641 1.64v.264c-.088 0-.176-.03-.234-.03h-.938c-.908 0-1.64.762-1.64 1.641v2.11H.234A.231.231 0 000 6.671v1.406c0 .147.088.235.234.235h.704v2.109c0 .908.732 1.64 1.64 1.64H3.75v.235c0 .908.732 1.64 1.64 1.64h.938c.879 0 1.64-.732 1.64-1.64V8.312h2.813v3.985c0 .908.733 1.64 1.64 1.64h.938c.88 0 1.641-.732 1.641-1.64v-.235h1.172c.879 0 1.64-.732 1.64-1.64v-2.11h.704a.231.231 0 00.234-.234V6.672a.252.252 0 00-.234-.234zm-15 4.218h-.938c-.146 0-.234-.088-.234-.234V4.328a.23.23 0 01.234-.234h.938c.117 0 .234.117.234.234v6.094a.231.231 0 01-.234.234zm3.046 1.64a.231.231 0 01-.234.235h-.937c-.147 0-.235-.088-.235-.234V2.453c0-.117.088-.234.235-.234h.937c.117 0 .234.117.234.234v9.844zm7.032 0a.231.231 0 01-.235.235h-.937c-.147 0-.235-.088-.235-.234V2.453c0-.117.088-.234.235-.234h.937c.118 0 .235.117.235.234v9.844zm2.812-1.874a.23.23 0 01-.234.234h-.938c-.146 0-.234-.088-.234-.234V4.328a.23.23 0 01.234-.234h.938c.117 0 .234.117.234.234v6.094z" fill="#030C16"/></svg>
            <span class="count"
              >{{
                program.programWorkoutsNumber
                  ? program.programWorkoutsNumber
                  : 0
              }}
              workouts</span
            >
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown
// stylelint-disable no-descending-specificity

.featured-program-default {
  width: 30rem;
  img {
    border-radius: $base-border-radius-md;
    width: 100%;
  }
}

.card-program-minimal {
  background-color: white;
  border: 1px solid rgba($color-black-wo-rgb, 0.2);
  border-radius: $base-border-radius-md;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  padding: 0.7em;
  &:not(.featured) {
    transition: transform 300ms;
    transition-timing-function: ease-out;
  }

  .menu {
    align-items: center;
    background: rgba($color-white-wo-rgb, 0.5);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    mix-blend-mode: normal;
    padding: 1rem 2rem;
    position: relative;
    width: fit-content;
  }
  .card-client-menu {
    backdrop-filter: blur(4px);
    background-color: rgba($color-white-wo-rgb, 0.5);
    border-radius: 50%;
    color: black;
    margin: 0;
    min-width: 0;
    padding: 0 0.5rem;
    position: relative;
    width: fit-content;

    // to override classes in card-menu-list
    ul {
      align-items: center;
      display: flex;
      justify-content: center;
    }
    ::v-deep .icon {
      height: 2rem;
      margin: 0;
      width: 2rem;
    }
    ::v-deep li {
      border-radius: 50%;
      &:hover {
        background-color: rgba($color-white-wo-rgb, 0);
        .icon {
          opacity: 1;
          path {
            fill: black;
          }
        }
      }
    }
  }

  .functionality-actions {
    display: flex;
    flex-direction: row-reverse;
    position: relative;
    right: 5%;
    top: -7rem;

    &.featured {
      justify-content: center;
      right: 1%;
    }
    // to add space btwn actions
    .action + .action {
      margin-right: 0.3rem;
    }
  }
  &:hover {
    box-shadow: 0 0.4rem 0.8rem rgba($color-black-wo-rgb, 0.1);
    cursor: pointer;
    transform: scale(1.01);
  }
  &.featured {
    background-color: $color-black-one;
    border: none;
    box-sizing: content-box;
    padding: 0;
    position: relative;
    width: 30rem;
    z-index: 2;
  }

  .card-hero {
    border-radius: $base-border-radius-md;
    width: 100%;
    &.featured {
      background-size: cover;
      border-radius: $base-border-radius-md $base-border-radius-md 0 0;
    }
  }

  .card-content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: -4rem;
    padding: 1rem 0.9rem 0.6rem;
    .card-title {
      -webkit-box-orient: vertical;
      color: $color-heading-text;

      /* Fallback for non-webkit */
      display: -webkit-box;
      font-family: $base-font-family;
      font-size: 2.1rem;
      font-style: normal;
      font-weight: 900;
      letter-spacing: -0.3px;

      /* Fallback for non-webkit */
      -webkit-line-clamp: 2;
      line-height: 2.4rem;
      margin: 0;
      max-width: 80%;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .card-meta {
      align-items: center;
      color: $color-black-one;
      display: flex;
      font-family: $base-font-family;
      font-size: 1.2rem;
      font-style: normal;
      font-weight: 800;
      justify-content: space-between;
      left: 2rem;
      letter-spacing: 0.1px;
      line-height: 1.6rem;
      mix-blend-mode: normal;
      padding-top: 1em;
      text-transform: uppercase;
      width: 100%;

      span {
        align-items: center;
        display: flex;
        margin-right: 0.4rem;
      }

      .icon-dumbbell,
      .icon-calendar {
        height: 2rem;
        margin-right: 0.5rem;
        width: 2rem;
        path {
          fill: $color-black-one;
        }
      }

      .count {
        position: relative;
        // top: 0.1rem;
      }
    }

    .featured-description {
      color: $color-dark-gray-three;
      font-family: $base-font-family;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      letter-spacing: 0.116667px;
      line-height: 19px;
    }

    &.featured {
      padding: 1rem 2rem;
      .card-title {
        color: $color-off-white;
        padding: 1.2rem 0;
      }
      .card-meta {
        color: $color-dark-gray-three;
        margin-top: -1rem;
        order: -1;
        .icon-calendar {
          path {
            fill: $color-dark-gray-three;
          }
        }
      }
    }
  }
}

.modal-dialog > .modal-content {
  .modal-text-main {
    color: $color-black-one;
    font-size: 28px;
    font-style: normal;
    font-weight: 900;
    letter-spacing: -0.233333px;
    line-height: 3.3rem;
    margin-left: 3rem;
    margin-right: 3rem;
    margin-top: 2rem;
    text-align: center;
  }
  .modal-text-second {
    color: $color-black-one;
    font-size: 18px;
    font-weight: 800;
    letter-spacing: -0.233333px;
    text-align: center;
  }
  .actions {
    display: flex;
    justify-content: space-around;
    padding-bottom: 2rem;
    padding-top: 2rem;
    .button {
      align-items: center;
      display: flex;
      height: 4rem;
      justify-content: center;
      width: 30%;
    }
  }
}

::v-deep .modal-dialog {
  min-width: 40%;
  .modal-content {
    background: $color-white;
    border-radius: 12px !important;
    box-shadow: 0 4px 8px rgba($color-black-wo-rgb, 0.08);
  }
}
</style>
